var _rect, _rect2, _rect3, _g, _rect4, _g2, _circle, _rect5, _rect6, _g3, _rect7, _rect8, _g4, _circle2, _rect9, _rect10, _path, _rect11, _path2, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadRepairIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.3696,
    y: 20.1102,
    width: 4.51021,
    height: 73.0655,
    fill: "#C4C8EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98.4556,
    y: 20.1102,
    width: 4.51021,
    height: 73.0655,
    fill: "#C4C8EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6873_126908",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 20,
    width: 5,
    height: 74
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 98.4556,
    y: 20.1102,
    width: 4.51021,
    height: 73.0655,
    fill: "#C4C8EA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6873_126908)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.3247,
    y: 36.205,
    width: 8.52616,
    height: 4.97359,
    fill: "#2538BF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.0352,
    y: 59.652,
    width: 8.52616,
    height: 4.97359,
    fill: "#2538BF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6873_126908",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 20,
    width: 5,
    height: 74
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3264,
    y: 20.1115,
    width: 4.51021,
    height: 73.0655,
    fill: "#C4C8EA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6873_126908)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.196,
    y: 36.2061,
    width: 8.52616,
    height: 4.97359,
    fill: "#2538BF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9065,
    y: 59.6531,
    width: 8.52616,
    height: 4.97359,
    fill: "#2538BF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.6248,
    cy: 19.2081,
    r: 3.60817,
    fill: "#545C93"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.80029,
    y: 23.7183,
    width: 103.735,
    height: 15.3347,
    fill: "#A8CCF8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6873_126908",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 23,
    width: 105,
    height: 17
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.80029,
    y: 23.7183,
    width: 103.735,
    height: 15.3347,
    fill: "#FFBF39"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6873_126908)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.7876,
    y: 22.88,
    width: 36.0817,
    height: 9.92247,
    transform: "rotate(130 28.7876 22.88)",
    fill: "#4793F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.1963,
    y: 22.88,
    width: 36.0817,
    height: 9.92247,
    transform: "rotate(130 50.1963 22.88)",
    fill: "#4793F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.8452,
    y: 22.88,
    width: 36.0817,
    height: 9.92247,
    transform: "rotate(130 71.8452 22.88)",
    fill: "#4793F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.4944,
    y: 22.9437,
    width: 36.0817,
    height: 9.92247,
    transform: "rotate(130 93.4944 22.9437)",
    fill: "#4793F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.143,
    y: 22.88,
    width: 36.0817,
    height: 9.92247,
    transform: "rotate(130 115.143 22.88)",
    fill: "#4793F1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 4.2478,
    y: 18.4419,
    width: 108.709,
    height: 8.52616,
    fill: "#2538BF"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.80029,
    y: 47.1715,
    width: 103.735,
    height: 15.3347,
    fill: "#A8CCF8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6873_126908",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 47,
    width: 105,
    height: 16
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.80029,
    y: 47.1715,
    width: 103.735,
    height: 15.3347,
    fill: "#FFBF39"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6873_126908)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.7876,
    y: 46.3331,
    width: 36.0817,
    height: 9.92247,
    transform: "rotate(130 28.7876 46.3331)",
    fill: "#4793F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.1963,
    y: 46.3331,
    width: 36.0817,
    height: 9.92247,
    transform: "rotate(130 50.1963 46.3331)",
    fill: "#4793F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.8452,
    y: 46.3331,
    width: 36.0817,
    height: 9.92247,
    transform: "rotate(130 71.8452 46.3331)",
    fill: "#4793F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.4941,
    y: 46.3966,
    width: 36.0817,
    height: 9.92247,
    transform: "rotate(130 93.4941 46.3966)",
    fill: "#4793F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.143,
    y: 46.3331,
    width: 36.0817,
    height: 9.92247,
    transform: "rotate(130 115.143 46.3331)",
    fill: "#4793F1"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.71,
    cy: 19.2081,
    r: 3.60817,
    fill: "#545C93"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2126,
    y: 93.1757,
    width: 10.8245,
    height: 2.70613,
    fill: "#545C93"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 95.2983,
    y: 93.1757,
    width: 10.8245,
    height: 2.70613,
    fill: "#545C93"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.416 73.4347C85.4534 70.5932 89.4722 70.5932 90.5095 73.4347L102.383 105.957H72.543L84.416 73.4347Z",
    fill: "#FFBF39"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 70.5967,
    y: 105.308,
    width: 33.7318,
    height: 3.89213,
    rx: 1.29738,
    fill: "#A8CCF8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_6873_126908",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 71,
    width: 31,
    height: 35
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.416 73.4347C85.4534 70.5932 89.4722 70.5932 90.5095 73.4347L102.383 105.957H72.543L84.416 73.4347Z",
    fill: "#FFBF39"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_6873_126908)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.5967,
    y: 94.2303,
    width: 33.7318,
    height: 5.2394,
    rx: 1.29738,
    fill: "#FF8422"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5969,
    y: 80.009,
    width: 33.7318,
    height: 5.2394,
    rx: 1.29738,
    fill: "#FF8422"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadRepairIllustration);
export default __webpack_public_path__ + "static/media/road-repair-illustration.d477cf489863903ab1c3db9e545ae03f.svg";
export { ForwardRef as ReactComponent };